/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerMinimalPersonDto } from './BorrowerMinimalPersonDto';
import {
    BorrowerMinimalPersonDtoFromJSON,
    BorrowerMinimalPersonDtoFromJSONTyped,
    BorrowerMinimalPersonDtoToJSON,
    BorrowerMinimalPersonDtoToJSONTyped,
} from './BorrowerMinimalPersonDto';
import type { BorrowerProjectDto } from './BorrowerProjectDto';
import {
    BorrowerProjectDtoFromJSON,
    BorrowerProjectDtoFromJSONTyped,
    BorrowerProjectDtoToJSON,
    BorrowerProjectDtoToJSONTyped,
} from './BorrowerProjectDto';
import type { LoanInfosDto } from './LoanInfosDto';
import {
    LoanInfosDtoFromJSON,
    LoanInfosDtoFromJSONTyped,
    LoanInfosDtoToJSON,
    LoanInfosDtoToJSONTyped,
} from './LoanInfosDto';

/**
 * 
 * @export
 * @interface GetBorrowerProjectInfosResponse
 */
export interface GetBorrowerProjectInfosResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBorrowerProjectInfosResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GetBorrowerProjectInfosResponse
     */
    folderIdentifier?: string;
    /**
     * 
     * @type {BorrowerProjectDto}
     * @memberof GetBorrowerProjectInfosResponse
     */
    project?: BorrowerProjectDto;
    /**
     * 
     * @type {Array<LoanInfosDto>}
     * @memberof GetBorrowerProjectInfosResponse
     */
    loans?: Array<LoanInfosDto>;
    /**
     * 
     * @type {Array<BorrowerMinimalPersonDto>}
     * @memberof GetBorrowerProjectInfosResponse
     */
    insureds?: Array<BorrowerMinimalPersonDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetBorrowerProjectInfosResponse
     */
    isPricingCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBorrowerProjectInfosResponse
     */
    isContractualizationCompleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBorrowerProjectInfosResponse
     */
    isProjectStepCompleted?: boolean;
}

/**
 * Check if a given object implements the GetBorrowerProjectInfosResponse interface.
 */
export function instanceOfGetBorrowerProjectInfosResponse(value: object): value is GetBorrowerProjectInfosResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetBorrowerProjectInfosResponseFromJSON(json: any): GetBorrowerProjectInfosResponse {
    return GetBorrowerProjectInfosResponseFromJSONTyped(json, false);
}

export function GetBorrowerProjectInfosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerProjectInfosResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'folderIdentifier': json['folderIdentifier'] == null ? undefined : json['folderIdentifier'],
        'project': json['project'] == null ? undefined : BorrowerProjectDtoFromJSON(json['project']),
        'loans': json['loans'] == null ? undefined : ((json['loans'] as Array<any>).map(LoanInfosDtoFromJSON)),
        'insureds': json['insureds'] == null ? undefined : ((json['insureds'] as Array<any>).map(BorrowerMinimalPersonDtoFromJSON)),
        'isPricingCompleted': json['isPricingCompleted'] == null ? undefined : json['isPricingCompleted'],
        'isContractualizationCompleted': json['isContractualizationCompleted'] == null ? undefined : json['isContractualizationCompleted'],
        'isProjectStepCompleted': json['isProjectStepCompleted'] == null ? undefined : json['isProjectStepCompleted'],
    };
}

export function GetBorrowerProjectInfosResponseToJSON(json: any): GetBorrowerProjectInfosResponse {
    return GetBorrowerProjectInfosResponseToJSONTyped(json, false);
}

export function GetBorrowerProjectInfosResponseToJSONTyped(value?: GetBorrowerProjectInfosResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'folderIdentifier': value['folderIdentifier'],
        'project': BorrowerProjectDtoToJSON(value['project']),
        'loans': value['loans'] == null ? undefined : ((value['loans'] as Array<any>).map(LoanInfosDtoToJSON)),
        'insureds': value['insureds'] == null ? undefined : ((value['insureds'] as Array<any>).map(BorrowerMinimalPersonDtoToJSON)),
        'isPricingCompleted': value['isPricingCompleted'],
        'isContractualizationCompleted': value['isContractualizationCompleted'],
        'isProjectStepCompleted': value['isProjectStepCompleted'],
    };
}

